/**
 * @module editablefield/uneditablefield
 */

import { Command } from 'ckeditor5/src/core';
import { first } from 'ckeditor5/src/utils';

const EDITABLE_FIELD = 'editablefield';

/**
 * The uneditablefield command. It is used by the {@link module:editablefield/editablefield~EditableField editablefield plugin}.
 *
 * @extends {Command}
 */
export default class UneditableFieldCommand extends Command {
	/**
	 * @inheritDoc
	 */
	refresh() {
		/**
		 * @type {Model}
		 */
		const model = this.editor.model;

		/**
		 * @type {DocumentSelection}
		 */
		const selection = model.document.selection;
		this.element = null;


		const block = first( selection.getSelectedBlocks() );
		let allowed = !!block && model.schema.checkChild( block, EDITABLE_FIELD );
		if ( allowed ) {
			this.element = selection.getSelectedElement();
		}
		this.isEnabled = this.element != null;
	}

	/**
	 * Executes the command.
	 *
	 * @fires execute
	 */
	execute() {
		const model = this.editor.model;

		model.change( writer => {
			const text = this.element.getAttribute( 'value' );
			const position = writer.createPositionBefore( this.element );
			writer.remove( this.element );
			if ( text ) {
				writer.insertText( text, position );
			}
			this.element = null;
		} );
	}
}
